import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { retrievePageMenu } from "../redux/slice/page-menu.slice";
import { retrieveSiteMap } from "../redux/slice/sitemap-slice";
import { RootState, useAppDispatch } from "../redux/store";
import { js2xml, Options } from 'xml-js';
import LoadingComp from "../components/re-usable/loading/loading";

interface Data {
    name: string;
    age: number;
    address: {
      city: string;
      state: string;
    };
  }


  const options: Options.JS2XML = {
    compact: true,
    ignoreComment: true,
    spaces: 4
  };


const Sitemap = () => {

    const dispatch = useAppDispatch()
    const { SiteMapData, SiteMapLoading } = useSelector((state: RootState) => state.SiteMap)

    useEffect(() => {
        dispatch(retrieveSiteMap())
    }, [dispatch])


    const xmlData = js2xml(SiteMapData, {compact: true, spaces: 4});

    

    return <>
        <style>
            {`
                .loader-container {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100Vh;
                }
            `}
        </style>
        <Helmet>
            {/* <title>{RapsEuropeData[0]?.result[0].menuItemName}</title> */}
        </Helmet>
        {/* {
            (SiteMapLoading) ? <LoadingComp /> : (
                <pre>{xmlData}</pre>
            )
        } */}
 
        </>


}

export default Sitemap
